import React from "react";
import { Input } from "components/bootstrap";
const ARN = ({
  awsARN = {
    value: ""
  },
  onChange
}) => /* @__PURE__ */ React.createElement(
  Input,
  {
    id: "awsAssumeRoleARN",
    type: "text",
    value: awsARN.value,
    onChange,
    label: "AWS Assume Role (ARN)",
    help: "Amazon Resource Name with required cross account permission",
    placeholder: "arn:aws:sts::123456789012:assumed-role/some-role",
    maxLength: 2048
  }
);
export default ARN;
